<div class="form-domain-script-guide-features-page-assist">
    <div class="form-group row" *ngIf="canUseFeature()">
        <label class="col-sm-8 col-form-label text-bold text-right" for="{{prefixName}}_add_page_assist" translate>
            Add PageAssist script
        </label>
        <div class="col-sm-40 pl-4">
            <div class="d-flex align-items-start">
                <form-field-material-switch name="{{prefixName}}_add_page_assist"
                                            [(ngModel)]="settingEnabled"
                                            (ngChange)="onEnabledChange($event)">
                </form-field-material-switch>
                <div class="pl-2" *ngIf="pageAssistModel.getVersionState() === 'v2'">
                    <button type="button"
                            [ngClass]="{'mon-disabled': !settingEnabled}"
                            (click)="settingEnabled && openPageAssistScriptSettings()"
                            [disabled]="!settingEnabled"
                            class="btn btn-link button-link-outline"
                            aria-haspopup="true"
                            translate>
                            Open PageAssist script settings
                    </button>
                </div>
            </div>

        </div>
    </div>

    <div *ngIf="canUseFeature() && settingEnabled && pageAssistModel.getVersionState() === 'v1'"
         class="row align-items-center switch-page-assist-version py-2 mb-4 ml-0 mr-0">
        <div class="col mr-auto text-white" translate>
            A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations
        </div>
        <div class="col-auto text-right">
            <button class="btn btn-border-radius btn-secondary" type="button" (click)="switchPageAssistSetting('v2')"
                    translate>Switch
                to new Version
            </button>
        </div>
    </div>
    <div *ngIf="supportLegacy && canUseFeature() && settingEnabled && pageAssistModel.getVersionState() === 'v2'"
        class="row align-items-center switch-page-assist-version v-1 py-2 mb-4 ml-0 mr-0">
        <div class="col mr-auto" translate>
            You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here
        </div>
        <div class="col-auto text-right">
            <button class="btn btn-border-radius btn-secondary" type="button" (click)="switchPageAssistSetting('v1')"
                    translate>Switch
                to old Version
            </button>
        </div>
    </div>

    <form-domain-script-guide-legacy-page-assist-settings
        *ngIf="canUseFeature() && settingEnabled && pageAssistModel.getVersionState() === 'v1'"
        prefixName="page_assist_legacy"
        [pageAssistModel]="pageAssistModel">
    </form-domain-script-guide-legacy-page-assist-settings>
</div>
